import React from 'react';
import { IconType } from './types/IconType';
import './Icon.scss';
import SvgIcon from './SvgIcon';
import { IconVariant, IconSize, IconColor } from './types/IconType';
// @ts-ignore
import classNames from 'classnames';
import styles from './Icon.module.scss';

const Icon = (props: IconType) => {
  switch (props.iconVariant) {
    case 'Custom':
      return (
        <div className={classNames(props.className)}>
          <SvgIcon name={props.icon} fill={props.color} width={props.size} height={props.size} />
        </div>
      );
    case 'FontAwesome': {
      const isInteractive = !!props.onClick && !!props.ariaLabel;
      if (isInteractive) {
        return (
          <button
            type="button"
            className={classNames(styles.iconButton, props.className, props.isPointer && styles.pointer)}
            style={{
              color: props.color,
              fontSize: props.size || 'fas',
            }}
            onClick={props.onClick}
            data-cy={props.dataCy}
            aria-label={props.ariaLabel}
          >
            <i className={props.icon}></i>
          </button>
        );
      }
      return (
        <span
          className={classNames(props.className, props.isPointer && styles.pointer)}
          style={{
            color: props.color,
            fontSize: props.size || 'fas',
          }}
          onClick={props.onClick}
          data-cy={props.dataCy}
          aria-label={props.ariaLabel}
        >
          <i className={props.icon}></i>
        </span>
      );
    }
    default:
      return <path />;
  }
};

Icon.Variants = IconVariant;
Icon.Size = IconSize;
Icon.Color = IconColor;

export default Icon;
